function hasParams(message, params) {
  if (params === void 0) {
    params = ['minChars', 'maxChars'];
  }

  return params.some(function (param) {
    return message.indexOf("{" + param + "}") >= 0;
  });
}

function messageInterpolation(message, params) {
  if (params) {
    Object.keys(params).forEach(function (key) {
      message = message.replace("{" + key + "}", params[key]);
    });
  }

  return message;
} // Computes the message to show if there is a min char condition. Uses translations to support multiple languages
// For one character needed - 1 more character needed
// For two or more characters needed - (n) more characters needed
// When condition is met - (n) character minimum


function getMinCharMessage(_ref) {
  var minCharCountMeet = _ref.minCharCountMeet,
      value = _ref.value,
      minChars = _ref.minChars,
      charCount = _ref.charCount,
      translations = _ref.translations;

  if (!minCharCountMeet && value !== '') {
    var minCharErrorMessage = translations.minCharErrorMessage;

    if (!hasParams(minCharErrorMessage)) {
      minCharErrorMessage = minCharErrorMessage.trim() + " {minChars}";
    }

    return messageInterpolation(minCharErrorMessage, {
      minChars: minChars - charCount
    });
  }

  var minCharMessage = translations.minCharMessage;

  if (!hasParams(minCharMessage)) {
    minCharMessage = "{minChars} " + minCharMessage.trim();
  }

  return messageInterpolation(minCharMessage, {
    minChars: minChars
  });
} // Check for any errors. Can be due to errorMsg, minimum count or maximum count


function checkForError(_ref2) {
  var errorMsg = _ref2.errorMsg,
      hasMinCountError = _ref2.hasMinCountError,
      maxCharCountExceeded = _ref2.maxCharCountExceeded;
  return !!errorMsg || hasMinCountError || maxCharCountExceeded;
} // Check for errors due to min count and if the control has been blurred


function checkForMinCountError(_ref3) {
  var minChars = _ref3.minChars,
      minCharCountMeet = _ref3.minCharCountMeet,
      value = _ref3.value,
      hasFocus = _ref3.hasFocus,
      hasBeenBlurred = _ref3.hasBeenBlurred;
  return minChars > 0 && !minCharCountMeet && (value !== '' && !hasFocus || hasBeenBlurred);
} // Suffix appended to Inline messages ID to reference for aria-describedby


export var FORM_ID_CONSTANTS = {
  MIN_CHAR: '__min-chars',
  MAX_CHAR: '__max-chars',
  HELP_TEXT: '__help'
};
var FormUtil = {
  // Method which computes props to be passed to FormHelpBlock
  computeHelpValues: function computeHelpValues(_ref4) {
    var id = _ref4.id,
        disabled = _ref4.disabled,
        helpText = _ref4.helpText,
        errorMsg = _ref4.errorMsg,
        value = _ref4.value,
        maxChars = _ref4.maxChars,
        minChars = _ref4.minChars,
        translations = _ref4.translations,
        hasBeenBlurred = _ref4.hasBeenBlurred,
        onlyShowMsgOnError = _ref4.onlyShowMsgOnError,
        hasFocus = _ref4.hasFocus,
        inverse = _ref4.inverse;
    var message = errorMsg || helpText;
    var charCount = value ? value.length : 0;
    var charCountDisplay = maxChars - charCount;
    var maxCharCountExceeded = maxChars > 0 && charCountDisplay < 0;
    var minCharCountMeet = minChars > 0 && charCount >= minChars;
    var hasMinCountError = checkForMinCountError({
      minChars: minChars,
      minCharCountMeet: minCharCountMeet,
      value: value,
      hasFocus: hasFocus,
      hasBeenBlurred: hasBeenBlurred
    });
    var hasError = checkForError({
      errorMsg: errorMsg,
      hasMinCountError: hasMinCountError,
      maxCharCountExceeded: maxCharCountExceeded
    });
    var minCharMessage = getMinCharMessage({
      minCharCountMeet: minCharCountMeet,
      value: value,
      minChars: minChars,
      charCount: charCount,
      translations: translations
    });
    var maxCharMessage = messageInterpolation(translations.maxCharErrorMessage, {
      maxChars: maxChars
    });
    return {
      id: id,
      helpText: helpText,
      errorMsg: errorMsg,
      message: message,
      maxChars: maxChars,
      minChars: minChars,
      disabled: disabled,
      charCountDisplay: charCountDisplay,
      onlyShowMsgOnError: onlyShowMsgOnError,
      maxCharCountExceeded: maxCharCountExceeded,
      minCharCountMeet: minCharCountMeet,
      hasMinCountError: hasMinCountError,
      minCharMessage: minCharMessage,
      maxCharMessage: maxCharMessage,
      inverse: inverse,
      hasError: hasError
    };
  },
  // Method used to check if there is a message or char count condition which requires an aria-described by pointer
  needAriaMsg: function needAriaMsg(_ref5) {
    var errorMsg = _ref5.errorMsg,
        helpText = _ref5.helpText,
        minChars = _ref5.minChars,
        maxCharCountExceeded = _ref5.maxCharCountExceeded;
    return errorMsg || helpText || minChars || maxCharCountExceeded;
  },
  // Method used to populate the input's aria-describedby prop
  computeAriaMsgList: function computeAriaMsgList(_ref6) {
    var id = _ref6.id,
        errorMsg = _ref6.errorMsg,
        helpText = _ref6.helpText,
        minChars = _ref6.minChars,
        maxCharCountExceeded = _ref6.maxCharCountExceeded;
    var descMsgList = ''; // if minChar condition exists, a message is always shown

    if (minChars !== 0) {
      descMsgList = "" + id + FORM_ID_CONSTANTS.MIN_CHAR + " ";
    } // if maxChar condition exists, a message is only shown when it exceeds the limit


    if (maxCharCountExceeded) {
      descMsgList = "" + descMsgList + id + FORM_ID_CONSTANTS.MAX_CHAR + " ";
    }

    if (errorMsg || helpText) {
      descMsgList = "" + descMsgList + id + FORM_ID_CONSTANTS.HELP_TEXT;
    }

    return descMsgList.trim();
  }
};
export default FormUtil;
//# sourceMappingURL=FormUtil.js.map